<script context="module">
  import { External, M } from '../../external';
  import VideoProperties from '../Admin/VideoProperties.svelte';
  import { defaultErrorHandling, updateVideoMetadata } from '../static';

  export let videoObjectGlobal = {};

  export function editVideoProperties(videoId, callback = () => {
  }) {
    External.Tools.showWindow({
      noTitle: true,
      width: 700,
      forceAtRight: true,
      isModal: true,
      withDarkBackground: true,
      buttons: [
        External.Button(M.OK, External.Button.CLASS_MIDDLE_BLUE, (popup) => {
          popup.close();
          if (!videoObjectGlobal.owner) {
            return;
          }
          updateVideoMetadata(videoObjectGlobal.id, videoObjectGlobal, () => callback(videoObjectGlobal));
        }),
        External.Button(M.CANCEL, External.Button.CLASS_MIDDLE_GREY, (popup) => {
          popup.close();
        })
      ],
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new VideoProperties({
              target: popup.getContentArea(),
              props: {
                onClose: () => {
                  popup.close();
                },
                initVideoData: true,
                videoId: videoId
              }
            })
          );
        }
      }
    });
  }
</script>

<script>
  import { onMount } from 'svelte';
  import { deleteVideoService, getVideoService } from '../static';
  import CommentAdminService, { HttpError } from '../../Common/CommentAdminService';
  import VideoPreview from './VideoPreview.svelte';
  import VideoAnalytic from '../Analytic/VideoAnalytic.svelte';
  import VideoCaptions from './VideoCaptions.svelte';
  import VideoShare from './VideoShare.svelte';
  import VideoCategories from './VideoCategories.svelte';
  import ContentOverlayList from './ContentOverlayList.svelte';
  import VideoCommentSection from './VideoCommentSection.svelte';
  import VideoSections from './VideoSections.svelte';

  export let video = {};
  export let initVideoData = false;
  export let videoId = 0;
  export let onClose = () => {
  };
  //variable used to force video preview to refresh, value is ignored
  let shouldRefreshVideo = 0;

  let setThumbnail = () => {
    if (video.thumbnail) {
      let thumbnailDiv = External.$('#videoObjectPropertyThumbnail');
      External.Tools.setImage(thumbnailDiv, video.thumbnailFileName, '160x120', video.thumbnailFileBase);
    }
  };

  let commentContext;
  const initCommentSection = async () => {
    if (!video.id || commentContext) {
      return;
    }

    try {
      commentContext = await CommentAdminService.getContext('video', video.id);
    } catch (error) {
      if (error instanceof HttpError) {
        // First time visit to this video, no context yet, create a new one
        if (error.statusCode === 404) {
          console.warn(error.message);

          commentContext = await CommentAdminService.createContext({
            resourceType: 'video',
            resourceId: video.id,
            moderation: { writePermission: 2, approvalRequired: 2 },
            commentModeration: { writePermission: 2, approvalRequired: 2 },
            extra: {
              allowMentions: true,
              allowImages: true
            }
          });
        }
      }
    }
  };

  let mounted = false;
  $: {
    if (mounted && video.id) {
      setThumbnail();
      setBackgroundColor();
      initCommentSection();
    }
  }

  onMount(() => {
    if (initVideoData) {
      getVideoService('/file/' + videoId)
      .then((videoData) => {
        video = videoData;
        videoObjectGlobal = video;

        mounted = true;
      })
      .catch((err) => {
        defaultErrorHandling();
      });
    } else {
      mounted = true;
    }
  });

  let setBackgroundColor = () => {
    let bgColorUI = External.$('#videoPropertyBgColor');
    let bgColor = video.backgroundColor ? video.backgroundColor : 'transparent';
    External.Tools.addColorPicker(bgColor, bgColorUI.prev(), bgColorUI, (color, colorClass) => {
      let hexColorVal = External.Tools.rgbaToHexNoAlpha(color);
      video.backgroundColor = hexColorVal;
    });
  };

  let updateThumbnail = (e) => {
    e.preventDefault();
    let thumbnailDiv = External.$('#videoObjectPropertyThumbnail');
    External.FileManager.selectFile({
      listImagesOnly: true,
      onCompleteCallback: (fileBase, fileName, displayName) => {
        External.Tools.setImage(thumbnailDiv, fileName, '160x120', fileBase);
        let url = External.getFileFromBase(fileBase) + fileName;
        video.thumbnail = url;
        video.thumbnailFileBase = fileBase;
        video.thumbnailFileName = fileName;
        shouldRefreshVideo++;
      }
    });
  };

  let removeThumbnail = () => {
    video.thumbnailFileBase = "";
    video.thumbnailFileName = "";
    video.thumbnail = "";
    setThumbnail();
    shouldRefreshVideo++;
  };


  let showCategories = () => {
    External.Tools.showWindow({
      title: M.VIDEO_CATEGORIES,
      width: 600,
      isModal: false,
      withDarkBackground: true,
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new VideoCategories({
              target: popup.getContentArea(),
              props: {
                video: video
              }
            })
          );
        },
        onHide: () => {

        }
      }
    });
  };

  let showCaptions = () => {
    let component;
    External.Tools.showWindow({
      title: M.CAPTION_SUBTITLES,
      width: 600,
      isModal: true,
      withDarkBackground: true,
      buttons: [
        External.Button(M.OK, External.Button.CLASS_MIDDLE_BLUE, (popup) => {
          popup.close();
          video.captions = component.getCaptions();
          shouldRefreshVideo++;
        }),
        External.Button(M.CANCEL, External.Button.CLASS_MIDDLE_GREY, (popup) => {
          popup.close();
        })
      ],
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            component = new VideoCaptions({
              target: popup.getContentArea(),
              props: {
                captions: video.captions
              }
            })
          );
        }
      }
    });
  };

  let showContentOverlayList = () => {
    External.Tools.showWindow({
      // title: 'Captions / Subtitles',
      width: 700,
      isModal: false,
      withDarkBackground: true,
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new ContentOverlayList({
              target: popup.getContentArea(),
              props: {
                video: video
              }
            })
          );
        }
      }
    });
  };

  let deleteVideo = () => {
    External.Tools.prompt(M.DELETE, External.format(M.DEL_CONFIRM_EXT, 'ext', video.name), () => {
      onClose();
      deleteVideoService('/file/' + video.id).catch((err) => {
        defaultErrorHandling();
      });
    });
  };

  let showAnalytics = () => {
    External.Tools.showWindow({
      title: '',
      height: 750,
      width: 1000,
      isModal: false,
      withDarkBackground: true,
      showCloseButton: true,
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new VideoAnalytic({
              target: popup.getContentArea(),
              props: {
                id: video.elementId,
                type: 'video'
              }
            })
          );
        }
      }
    });
  };

  let showCommentSettings = () => {
    External.Tools.showWindow({
      title: M.COMMENTS,
      width: 500,
      isModal: false,
      withDarkBackground: true,
      buttons: [
        External.Button(M.OK, External.Button.CLASS_MIDDLE_BLUE, async (popup) => {
          const changeSet = popup.component().getChangeSet();
          commentContext = await CommentAdminService.partialUpdateContext('video', video.id, changeSet);
          popup.close();
        }),
        External.Button(M.CANCEL, External.Button.CLASS_MIDDLE_GREY, (popup) => {
          popup.close();
        })
      ],
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new VideoCommentSection({
              target: popup.getContentArea(),
              props: {
                context: commentContext
              }
            })
          );
        }
      }
    });
  };

  let showVideoSectionSettings = () => {
    External.Tools.showWindow({
      width: 500,
      isModal: false,
      withDarkBackground: true,
      buttons: [
        External.Button(M.OK, External.Button.CLASS_MIDDLE_BLUE, async (popup) => {
          video.timestamps = popup.component().getTimestamps();

          updateVideoMetadata(video.id, video, () => popup.close());
        }),
        External.Button(M.CANCEL, External.Button.CLASS_MIDDLE_GREY, (popup) => {
          popup.close();
        })
      ],
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new VideoSections({
              target: popup.getContentArea(),
              props: {
                video: video
              }
            })
          );
        }
      }
    });
  };

  let showShareVideo = () => {
    External.Tools.showWindow({
      title: M.SHARE_VIDEO,
      width: 750,
      isModal: false,
      withDarkBackground: true,
      showCloseButton: true,
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new VideoShare({
              target: popup.getContentArea(),
              props: {
                videoElementId: video.elementId,
                videoDuration: video.durationInMs,
                videoSource: video.videoPath
              }
            })
          );
        }
      }
    });
  };
</script>

{#if mounted}
  {#if !video.owner}
    <div class="padded-crm-wrapper-outer">
      <div class="limit-warning-line flex align-center col20 mt-15">
        {M.VIDEO_READ_ONLY_MESSAGE}
      </div>
    </div>
  {/if}
  <div class="padded-crm-wrapper-outer" class:disabled={!video.owner} style="max-width: 1000px; max-width: 90%;">
    <div class="platform-video-wrapper mb-15 mt-25 col20 f-left">
      <div class="video-processing flex align-center justify-center">
        {#if video.jobStatus !== 'COMPLETE'}
          <div class="checkout-spinner-wrapper t-center">
            <div class="checkout-spinner"></div>
            <h4>{M.VIDEO_IS_PROCESSING}</h4>
            <span>{M.VIDEO_IS_PROCESSING_DESC}</span>
          </div>
        {:else}
          {#key shouldRefreshVideo}
            <VideoPreview {video} />
          {/key}
        {/if}
      </div>
    </div>
    <div class="col20 f-left mt-10">
      <div class="col9 f-left">
        <div class="popup-input-wrapper">
          <h5>{M.VIDEO_TITLE}</h5>
          <input type="text" name="videoTitle" placeholder={M.ADD_VIDEO_TITLE} bind:value={video.title} />
        </div>
        <div class="popup-input-wrapper">
          <h5>{M.DESCRIPTION}</h5>
          <input type="text" name="videoTitle" placeholder={M.ADD_VIDEO_DESC} bind:value={video.description} />
        </div>
        <div class="popup-input-wrapper f-right color-pick-wrap-widgets">
          <div class="color-pick-wrap">
            <div></div>
            <input type="text" value="" class="colorpicker-selected modify" id="videoPropertyBgColor" name="bgColor" />
          </div>
          <div class="info">
            <h5>{M.BACKGROUND_COLOR}</h5>
          </div>
        </div>
        <div class="popup-input-wrapper">
          <h5>{M.VIDEO_THUMB}</h5>
          <a
            id="videoObjectPropertyThumbnail"
            class="add-image transition-all mt-10 f-left"
            on:click={updateThumbnail}
            style="background-image: url(&quot;{External.getThumbnailsFromBase(video.thumbnailFileBase, '160x120') +
              video.thumbnailFileName}&quot;);">
            <span class="add-button transition-all"> </span>
            {#if video.thumbnail}
              <span class="image-remove-btn red transition-all f-right" on:click|stopPropagation={removeThumbnail}>
                <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"
                ><path
                  d="M261-120q-24.75 0-42.375-17.625T201-180v-570h-41v-60h188v-30h264v30h188v60h-41v570q0 24-18 42t-42 18H261Zm438-630H261v570h438v-570ZM367-266h60v-399h-60v399Zm166 0h60v-399h-60v399ZM261-750v570-570Z" /></svg>
              </span>
            {/if}
          </a>
        </div>
      </div>
      <div class="col9 f-right">
        <div class="col20 f-left gray-section product-select-wrapper mb-5">
          <div class="col20 f-left ab-step center-vertically">
            <h4 class="roboto">{M.CATEGORIES}</h4>
            <a class="text-link blue-text" data-role="changeTextStyles" on:click={showCategories}>{M.SETTINGS}</a>
          </div>
        </div>
        <!--
        <div class="col20 f-left gray-section product-select-wrapper mb-5">
          <div class="col20 f-left ab-step center-vertically">
            <h4 class="roboto">{M.CONTENT_OVERLAY}</h4>
            <a class="text-link blue-text" data-role="changeTextStyles" on:click={showContentOverlayList}>{M.SETTINGS}</a>
          </div>
        </div>
        -->
        <div class="col20 f-left gray-section product-select-wrapper mb-5">
          <div class="col20 f-left ab-step center-vertically">
            <h4 class="roboto">{M.VIDEO_CHAPTERS}</h4>
            <a class="text-link blue-text" on:click={showVideoSectionSettings}>{M.SETTINGS}</a>
          </div>
        </div>
        {#if commentContext}
          <div class="col20 f-left gray-section product-select-wrapper mb-5">
            <div class="col20 f-left ab-step center-vertically">
              <h4 class="roboto">{M.COMMENTS}</h4>
              <a class="text-link blue-text" data-role="changeTextStyles" on:click={showCommentSettings}
              >{M.SETTINGS}</a>
            </div>
          </div>
        {/if}
        <div class="col20 f-left gray-section product-select-wrapper mb-5">
          <div class="col20 f-left ab-step center-vertically">
            <h4 class="roboto">{M.CAPTIONS}</h4>
            <a class="text-link blue-text" data-role="changeTextStyles" on:click={showCaptions}>{M.SETTINGS}</a>
          </div>
        </div>
        {#if video.jobStatus === 'COMPLETE'}
          <div class="col20 f-left gray-section product-select-wrapper mb-15">
            <div class="col20 f-left ab-step center-vertically">
              <h4 class="roboto">{M.ANALYTICS}</h4>
              <a class="text-link blue-text" data-role="changeTextStyles" on:click={showAnalytics}>{M.SHOW}</a>
            </div>
          </div>
          <button class="middle-button blue rounded-effect mr-5 mb-5" on:click={showShareVideo}>{M.SHARE}</button>
          <button class="middle-button gray rounded-effect" on:click={deleteVideo}>{M.DELETE_VIDEO}</button>
        {/if}
      </div>
    </div>
  </div>
{/if}
